import React, { useState, useEffect } from "react";
import PopupContainer from "./PopupContainer";
import "./VideoBox.css";
import Loader from "./Loader";

const VideoBox = props => {
  const [newLink, setNewLink] = useState();
  const [isLoaded, setIsLoaded] = useState(false);

  const getLink = () => {
    const { link } = props;
    if (link.includes("youtube") && link.includes("v=")) {
      const newLink = link.substring(link.indexOf("v=") + 2);
      setNewLink(`//www.youtube.com/embed/${newLink}`);
    }
    if (link.includes("youtube.com/embed/")) {
      setNewLink(link);
    }
    if (link.includes("youtu.be")) {
      const newLink = link.substring(link.indexOf(".be/") + 4);
      setNewLink(`//www.youtube.com/embed/${newLink}`);
    }
    if (link.includes("vimeo.com")) {
      const newLink = link.substring(link.indexOf(".com/") + 5);
      setNewLink(
        `//player.vimeo.com/video/${newLink}?autoplay=0&byline=0&portrait=0&color=cccccc`
      );
    }
    if (link.includes("player.vimeo.com")) {
      setNewLink(link);
    }
  };

  useEffect(() => {
    getLink();
  }, [props.link]);
  return (
    <PopupContainer onExit={props.onExit}>
      <div className={isLoaded ? "videoContent loaded" : "videoContent"}>
        <div className="videoBox">
          <iframe
            onLoad={setIsLoaded}
            title={newLink}
            src={newLink}
            frameBorder="0"
            width="1280"
            height="720"
            allowFullScreen=""
          ></iframe>
        </div>
      </div>
      {isLoaded ? "" : <Loader />}
    </PopupContainer>
  );
};

export default VideoBox;



// WEBPACK FOOTER //
// ./src/components/VideoBox.jsx